export default __webpack_public_path__ + "static/media/block_image.0dab3d78.svg";